import { render, staticRenderFns } from "./AppTelefone.vue?vue&type=template&id=2d1c0ca2&scoped=true&"
import script from "./AppTelefone.vue?vue&type=script&lang=js&"
export * from "./AppTelefone.vue?vue&type=script&lang=js&"
import style0 from "./AppTelefone.vue?vue&type=style&index=0&id=2d1c0ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1c0ca2",
  null
  
)

export default component.exports